import {Component} from '@angular/core';
import {AuthOktaService} from "../../../shared/services/auth/auth-okta.service";

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.html',
  styleUrls: ['./access-denied.scss']
})
export class AccessDeniedContainer {
  constructor(private authOktaService: AuthOktaService) {
  }

  logout() {
    this.authOktaService.signOut();
  }
}
